// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"87157048a0ea569c","node_modules_dompurify_dist_purify_js":"a7c07e15d6f5903a","node_modules_canvg_lib_index_es_js":"0f2f93c1fe8542f3"}[chunkId] + ".js";
};